import React from "react";
import { Field } from "redux-form";
import { connect } from "react-redux";
import * as actions from "MODULES/users/actions";
import {
  form,
  Form as AppForm,
  FormInput
} from "MODULES/shared/components/Forms";
import { PASSWORD } from "APP_ROOT/constants";
import validate from "./validate";

export function Form(props) {
  const password = document.querySelector("#password");
  const confirm = document.querySelector("#confirm");

  const handleClickPassword = () => {
    const type = password.getAttribute("type") === PASSWORD ? "text" : PASSWORD;
    password.setAttribute("type", type);
  };

  const handleClickConfirmation = () => {
    const type = confirm.getAttribute("type") === PASSWORD ? "text" : PASSWORD;
    confirm.setAttribute("type", type);
  };

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <Field
          name="password"
          component={FormInput}
          type="password"
          addon={
            <i
              style={{ cursor: "pointer" }}
              className="fa fa-fw fa-eye"
              onClick={handleClickPassword}
            />
          }
          label="Password"
          required
        />
        <Field
          name="confirm"
          component={FormInput}
          type="password"
          addon={
            <i
              style={{ cursor: "pointer" }}
              className="fa fa-fw fa-eye"
              onClick={handleClickConfirmation}
            />
          }
          label="Retype Password"
          required
        />
      </AppForm.Body>
    </AppForm>
  );
}

export default connect(undefined, { onSubmit: actions.update })(
  form({
    form: "updatePassword",
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/users/components/UpdatePassword/Form.jsx